import { render } from "./VerifyTwoFa.vue?vue&type=template&id=7c8ae038&scoped=true"
import script from "./VerifyTwoFa.vue?vue&type=script&lang=js"
export * from "./VerifyTwoFa.vue?vue&type=script&lang=js"

import "./VerifyTwoFa.vue?vue&type=style&index=0&id=7c8ae038&lang=less&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8ae038"]])

export default __exports__